export default __webpack_public_path__ + "static/media/cart-05-PT.6982edd0.jpg";